import { action, observable } from 'mobx';
import {
    IPicTimeConnectedGallery,
    IPicTimeProjectTemplate
} from '~/apps/main/PicTime/pic-time.types';
import { BasePicTimeGalleriesStore } from '~/apps/main/Workspace/SidebarTools/PicTime/stores/BasePicTimeGalleries.store';

export class PicTimeGalleriesStore extends BasePicTimeGalleriesStore {
    @observable projectsTemplates: IPicTimeProjectTemplate[] = [];

    @action.bound
    addGallery(gallery: IPicTimeConnectedGallery) {
        this.galleries.push(gallery);
    }

    @action.bound
    updateGallery(gallery: IPicTimeConnectedGallery) {
        this.galleries = this.galleries.map(_gallery =>
            _gallery.pictime_project_id === gallery.pictime_project_id
                ? gallery
                : _gallery
        );
    }

    @action.bound
    setProjectsTemplates(projectsTemplates: IPicTimeProjectTemplate[]) {
        this.projectsTemplates = projectsTemplates;
    }
}
